import { IcoLock } from '@components/icons';

type BadgeType = 'secure-checkout' | 'money-back' | 'stripe';

type Props = {
  badges?: BadgeType[];
  guaranteeText?: string;
  phone?: string;
  altPaymentText?: string;
};

function TrustBadge({ type }: { type: BadgeType }) {
  switch (type) {
    case 'secure-checkout':
      return (
        <span class="flex items-center gap-1.5">
          <IcoLock class="size-4" />
          100% Secure Checkout
        </span>
      );
    case 'money-back':
      return <span>Money-Back Guarantee</span>;
    case 'stripe':
      return <span>Powered by Stripe</span>;
  }
}

export function TrustBar({ badges, guaranteeText, phone, altPaymentText }: Props) {
  return (
    <div class="max-w-3xl mx-auto px-6 py-8 text-center">
      {badges && badges.length > 0 && (
        <div class="flex items-center justify-center gap-6 text-gray-500 text-sm">
          {badges.map((badge) => (
            <TrustBadge key={badge} type={badge} />
          ))}
        </div>
      )}
      {guaranteeText && <p class="mt-4 text-gray-600 text-sm">{guaranteeText}</p>}
      {phone && (
        <p class="mt-2 text-gray-500 text-sm">
          <strong>Want to place your order by phone?</strong> Please call{' '}
          <a href={`tel:${phone}`} class="text-blue-600 hover:underline">
            {phone}
          </a>
        </p>
      )}
      {altPaymentText && <p class="mt-2 text-gray-500 text-sm">{altPaymentText}</p>}
    </div>
  );
}
